import LocalizedStrings from 'localized-strings';

import { getMobileAppLang } from 'features/Accounting/pages/Estimation/common/utils';

export const locales = new LocalizedStrings(
  {
    en: {
      description:
        'You can now view a more precise estimate of the social security contributions to be paid.',
      finish: 'Close',
      title: 'Your settings have been updated!',
    },
    fr: {
      description:
        'Vous pouvez maintenant visualiser une estimation plus précise des cotisations sociales à verser.',
      finish: 'Terminer',
      title: 'Vos paramètres ont été mis à jour !',
    },
  } as const,
  {
    customLanguageInterface: getMobileAppLang,
  },
);
